module.exports = __webpack_public_path__ + "img/filter.d1c6da57.svg";